import React from "react"
import Modal from 'app/components/Modal'
import { useState, useCallback } from "react"
import Menu from 'app/layout/Menu'

export default ({ text }) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => {
    setIsOpen(true)
  }, [])

  const close = useCallback(() => {
    setIsOpen(false)
  }, [])

  return <>
           <Modal isOpen={ isOpen } close={ close } header="Menu">
             <Menu onNav={ close } />
           </Modal>

           <div className="header">
             <div className="header-text">
               { text }
             </div>
             <div className="header-menu-icon-wrapper" onClick={ open }>
               <i className="ph ph-list" />
             </div>
           </div>
         </>
};
